import Vue from 'vue'
import Vuex from 'vuex'
import {get, set } from '../utils/localStorage.js'
import { Message, Loading } from 'element-ui'
import { addMemberLike, getMemberLike } from "../api";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        number: 2,
        menuOpen: false,
        userInfo: '',
        favoriteProduct: [],
        goodsInd: [],
        guideInd: []
    },
    mutations: {
        SET_CART_NUMBER: (state) => {
            // state.number++;
            state.userInfo.shopcar++;
            // state.number = userInfo.shopcar;
            set('userInfo', state.userInfo);
        },
        MINUS_CART_NUMBER: (state) => {
            state.userInfo.shopcar--;
            set('userInfo', state.userInfo);
            // state.number--;
        },
        TOGGLE_MENU: (state, payload) => {
            state.menuOpen = !state.menuOpen;
        },
        CLOSE_MENU: (state) => {
            state.menuOpen = false;
        },
        SET_USER_INFO: (state, userInfo) => {
            console.log('*********************************');
            console.log('* vuex mutations: SET_USER_INFO *');
            console.log('*********************************');
            state.userInfo = userInfo;
            state.number = userInfo.shopcar;
        },
        CLEAN_USER_INFO: (state) => {
            console.log('CLEAN_USER_INFO');
            state.userInfo = '';
        },
        ADD_PRODUCT_FAVORITE: (state, id) => {
            console.log('ADD_PRODUCT_FAVORITE: pid ' + id);
            state.favoriteProduct.push(id);
        },
        REMOVE_PRODUCT_FAVORITE: (state, id) => {
            console.log('id', id);
            console.log('state.favoriteProduct', state.favoriteProduct);
            const newList = state.favoriteProduct.filter(item => item != id);
            console.log('newlist', newList);
            state.favoriteProduct = newList;
        },
        SET_PRODUCT_FAVORITE: (state, favoriteProductList) => {
            state.favoriteProduct = favoriteProductList;
        },
        SET_GOODS_IND: (state, payload) => {
            state.goodsInd = payload;
        },
        SET_GUIDE_IND: (state, payload) => {
            state.guideInd = payload;
        }
    },
    actions: {
        handleMemberLike: ({ commit, state }, id) => {
            return new Promise(async(resolve, reject) => {
                console.log('检查');
                let loadingInstance = '';
                try {
                    if (!check_login_status()) return;
                    console.log('submit');
                    loadingInstance = Loading.service({
                        lock: true,
                    });
                    await addMemberLike({ product_id: id });
                    console.log('submit done');
                    if (state.favoriteProduct.includes(id)) {
                        console.log('remove');
                        commit('REMOVE_PRODUCT_FAVORITE', id);
                    } else {
                        console.log('add');
                        commit('ADD_PRODUCT_FAVORITE', id);
                    }
                    loadingInstance.close();
                    resolve();
                } catch (error) {
                    console.log('error', error);
                    loadingInstance.close();
                    resolve();
                }
            })
        },
    },
    modules: {}
})

function check_login_status() {
    const token = get('token');
    if (!token) {
        Message({
            message: '请先登入在操作！',
            type: 'warning',
            duration: 2 * 1000
        })
        return false;
    }
    return true;
}